import _defineProperty from 'babel-runtime/helpers/defineProperty'
import classNames from 'classnames'
import Modal from 'ant-design-vue/es/modal/Modal'
import ActionButton from 'ant-design-vue/es/modal/ActionButton'
import { getConfirmLocale } from 'ant-design-vue/es/modal/locale'

export default {
  functional: true,
  render: function render (h, context) {
    var props = context.props
    var onCancel = props.onCancel
    var onOk = props.onOk
    var close = props.close
    var zIndex = props.zIndex
    var afterClose = props.afterClose
    var visible = props.visible
    var keyboard = props.keyboard
    var centered = 'centered' in props ? props.centered : true
    var getContainer = props.getContainer
    var maskStyle = props.maskStyle
    var okButtonProps = props.okButtonProps
    var cancelButtonProps = props.cancelButtonProps
    var _props$closable = props.closable
    var closable = _props$closable === undefined ? true : _props$closable

    var okType = props.okType || 'primary'
    var prefixCls = props.prefixCls || 'ant-modal'
    var contentPrefixCls = prefixCls + '-confirm'
    // 默认为 true，保持向下兼容
    var okCancel = 'okCancel' in props ? props.okCancel : false
    var okSubmit = 'okSubmit' in props ? props.okSubmit : false
    var width = props.width || 416
    var height = props.height || 416
    var style = props.style || {}
    var mask = props.mask === undefined ? true : props.mask
    // 默认为 true，保持旧版默认行为
    var maskClosable = props.maskClosable === undefined ? true : props.maskClosable
    var runtimeLocale = getConfirmLocale()
    var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText)
    var cancelText = props.cancelText || runtimeLocale.cancelText
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok'
    var transitionName = props.transitionName || 'zoom'
    var maskTransitionName = props.maskTransitionName || 'fade'

    var cancelButton = okCancel && h(
      ActionButton,
      {
        attrs: {
          actionFn: onCancel,
          closeModal: close,
          autoFocus: autoFocusButton === 'cancel',
          buttonProps: cancelButtonProps
        }
      },
      [cancelText]
    )

    var okButton = okSubmit && h(
      ActionButton,
      {
        attrs: {
          type: okType,
          actionFn: onOk,
          closeModal: close,
          autoFocus: autoFocusButton === 'ok',
          buttonProps: okButtonProps
        }
      },
      [okText]
    )

    return h(
      Modal,
      {
        attrs: {
          prefixCls: prefixCls,

          wrapClassName: classNames(_defineProperty({}, contentPrefixCls + '-centered', !!centered)),

          visible: visible,
          closable: closable,
          title: props.title,
          transitionName: transitionName,
          footer: '',
          maskTransitionName: maskTransitionName,
          mask: mask,
          maskClosable: maskClosable,
          maskStyle: maskStyle,

          width: width,
          zIndex: zIndex,
          afterClose: afterClose,
          keyboard: keyboard,
          centered: centered,
          getContainer: getContainer,
          bodyStyle: { padding: 0 }
        },
        on: {
          'cancel': function cancel (e) {
            return close({ triggerCancel: true }, e)
          }
        },
        style: style
      },
      [
        h(
          'iframe',
          {
            attrs: {
              src: props.path,
              frameborder: 0,
              width: '100%',
              height: height
            }
          }
        ),
        (cancelButton || okButton) && h(
          'div',
          { 'class': prefixCls + '-footer' },
          [cancelButton, okButton]
        )
      ]
    )
  }
}
